import { useRef } from 'react';
import { shuffle, getContrastColor } from '../../utils/utils';
import Backdrop from './Backdrop';
import { FilterIcon, ShareIcon } from '../Icons';

const LiveGalleryDemo = (props) => {
  const { accentColor, background, logo, title, subtitle, buttonFlag, buttonText, backdrop, theme = 'dark' } = props;

  const getBackgroundEl = () => {
    if (!background) {
      return null;
    }
    return ['mp4', 'm4v'].includes(background.split('.').pop()) ? (
      <video className="lg-demo__background" src={`${background}#t=0.1`} autoPlay loop muted playsInline />
    ) : (
      <img className="lg-demo__background" alt="" src={background} />
    );
  };
  const backgroundEl = getBackgroundEl();

  const getGridPhotos = () => {
    const photos = [];
    for (let modelIndex = 4; modelIndex < 6; modelIndex += 1) {
      for (let photoIndex = 0; photoIndex < 4; photoIndex += 1) {
        photos.push(`/static/model/${modelIndex}/${photoIndex}.png`);
      }
    }
    return shuffle(photos);
  };

  const gridPhotos = useRef(getGridPhotos());
  const accentTextColor = useRef(getContrastColor(accentColor));

  const lgDemo = (type) => (
    <div className={`lg-demo lg-demo--${type}`}>
      <div className={`lg-demo__hero lg-demo__hero--${theme}`}>
        {backgroundEl}
        <div>
          {logo && <img src={logo} className="lg-demo__logo" alt="" />}
          <h3 className="lg-demo__title">{title}</h3>
          {subtitle && <h4 className="lg-demo__subtitle">{subtitle}</h4>}
          {!!buttonFlag && !!buttonText && (
            <div
              className="lg-demo__btn"
              style={{
                backgroundColor: accentColor,
                color: accentTextColor.current,
              }}
            >
              {buttonText}
            </div>
          )}
        </div>
      </div>
      <div
        className="lg-demo__toolbar"
        style={{
          background: accentColor,
          color: accentTextColor.current,
          fill: accentTextColor.current,
        }}
      >
        <ShareIcon />
        <div>
          <div className="lg-demo__filter">
            Newest &rarr; Oldest <FilterIcon />
          </div>
        </div>
        <ShareIcon />
      </div>
      <div className="lg-demo__photos">
        {gridPhotos.current.map((src) => (
          <div key={src} className="lg-demo__photo">
            <Backdrop backdrop={backdrop} />
            <img src={src} alt="" />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="responsive-demo">
      <div className="macbook-demo">
        <div className="macbook-demo__phone">
          <div className="macbook-demo__screen">{lgDemo('desktop')}</div>
        </div>
      </div>
      <div className="iphone-demo">
        <div className="iphone-demo__phone">
          <div className="iphone-demo__screen">{lgDemo('mobile')}</div>
        </div>
      </div>
    </div>
  );
};

export default LiveGalleryDemo;
